module.exports = __webpack_public_path__ + "static/media/dev_computer.9fd156e6.png";